<ion-header class="ion-no-border">
  <ion-item lines="full">
    <ion-label>
      <h6 class="bold">Participants</h6>
    </ion-label>

    <ion-button
      aria-label="Get invite link"
      fill="clear"
      *ngIf="(role$ | async) >= roleLimits.PARTICIPANT_CREATE"
      (click)="openInvitationLinkMenu($event, 'The Stage')"
      tooltip="Get invite link">
      Invite
    </ion-button>

    <ion-button aria-label="Close" (click)="closeSidebar.emit()" tooltip="Close" fill="clear">
      <ion-icon src="/assets/icons/24px/close.svg" slot="icon-only"> </ion-icon>
    </ion-button>
  </ion-item>
</ion-header>

<ion-content >
  <ion-list>
    <ion-item class="location-header no-hover">
      <ion-label>The Stage</ion-label>
    </ion-item>

    <div *ngIf="studioSession$?.value?.confType !== 'daily'">
      <div
        *ngFor="let participant of onStageDolby; trackBy: trackByOnStageDolby; last as onStageLast"
        class="participant-item">
        <ion-item lines="none">
          <sc-avatar [photoURL]="participant.photoURL" [name]="participant.name$ | async"></sc-avatar>

          <ion-label>
            <p class="medium ion-no-padding ion-no-margin" [tooltip]="participant.name$ | async">
              {{ participant.name$ | async }}
            </p>

            <p class="micro-regular ion-no-padding ion-no-margin">
              {{ rolesService.display(participant.role) }}
            </p>
          </ion-label>

          <ion-button
            *ngIf="(role$ | async) >= roleLimits.PARTICIPANT_UPDATE"
            aria-label="Toggle Participant Mute"
            (click)="toggleParticipantMute(participant)"
            class="black">
            <ion-icon
              [src]="
                (participant.equipment$ | async)?.mute ? '/assets/icons/16px/mic-off.svg' : '/assets/icons/16px/mic.svg'
              "
              slot="icon-only"></ion-icon>
          </ion-button>

          <ion-button
            *ngIf="(role$ | async) >= roleLimits.PARTICIPANT_UPDATE && (participant.equipment$ | async)?.videoIn"
            aria-label="Toggle Participant Video Off"
            (click)="toggleParticipantVideoOff(participant)"
            class="black">
            <ion-icon
              [src]="
                (participant.equipment$ | async)?.videoOff
                  ? '/assets/icons/16px/video-off.svg'
                  : '/assets/icons/16px/video.svg'
              "
              slot="icon-only"></ion-icon>
          </ion-button>

          <ion-button
            aria-label="Open Participant Menu"
            (click)="openParticipantMenu($event, participant, 'the stage')"
            class="black">
            <ion-icon src="/assets/icons/24px/more-vertical.svg" slot="icon-only"></ion-icon>
          </ion-button>
        </ion-item>

        <sc-participant-equipment
          [equipment$]="participant.equipment$"
          [uid]="participant.uid"></sc-participant-equipment>
        <hr *ngIf="!onStageLast" />
      </div>
    </div>
    <div *ngIf="studioSession$?.value?.confType === 'daily'">
      <div
        *ngFor="let participant of participantsDaily; trackBy: trackByParticipantDaily; last as participantDailyLast"
        class="participant-item">
        <ion-item lines="none">
          <sc-avatar [photoURL]="participant.photoURL" [name]="participant.name$ | async"></sc-avatar>

          <ion-label>
            <p class="medium ion-no-padding ion-no-margin" [tooltip]="participant.name$ | async">
              {{ participant.name$ | async }}
            </p>
          </ion-label>

          <ion-button
            *ngIf="(role$ | async) >= roleLimits.PARTICIPANT_UPDATE"
            aria-label="Toggle Participant Mute"
            (click)="toggleParticipantMute(participant)"
            class="black">
            <ion-icon
              [src]="
                (participant.equipment$ | async)?.mute ? '/assets/icons/16px/mic-off.svg' : '/assets/icons/16px/mic.svg'
              "
              slot="icon-only"></ion-icon>
          </ion-button>

          <ion-button
            *ngIf="(role$ | async) >= roleLimits.PARTICIPANT_UPDATE && (participant.equipment$ | async)?.videoIn"
            aria-label="Toggle Participant Video Off"
            (click)="toggleParticipantVideoOff(participant)"
            class="black">
            <ion-icon
              [src]="
                (participant.equipment$ | async)?.videoOff
                  ? '/assets/icons/16px/video-off.svg'
                  : '/assets/icons/16px/video.svg'
              "
              slot="icon-only"></ion-icon>
          </ion-button>

          <ion-button
            aria-label="Open Participant Menu"
            (click)="openParticipantMenu($event, participant, 'the stage')"
            class="black">
            <ion-icon src="/assets/icons/24px/more-vertical.svg" slot="icon-only"></ion-icon>
          </ion-button>
        </ion-item>

        <sc-participant-equipment
          [equipment$]="participant.equipment$"
          [uid]="participant.userData.scUID"></sc-participant-equipment>
        <hr *ngIf="!participantDailyLast" />
      </div>
    </div>

    <div *ngIf="!onStageDolby.length && (role$ | async) >= roleLimits.PARTICIPANT_CREATE" class="invite-prompt">
      <ion-button
        aria-label="Open Invitaion Link Menu"
        (click)="openInvitationLinkMenu($event, 'The Stage')"
        class="line"
        expand="block">
        Invite on The Stage
      </ion-button>

      <p class="micro-regular ion-text-center">
        These are your hosts and guests that will be talking on microphone and camera in the session. They will be
        recorded but do not have any controls for the session unless they are part of your team.
      </p>
    </div>

    <ion-item *ngIf="studioSession$?.value?.confType !== 'daily'" class="location-header no-hover">
      <ion-label>Backstage</ion-label>
    </ion-item>

    <ion-list *ngIf="studioSession$?.value?.confType !== 'daily'">
      <ion-item
        *ngFor="let participant of backstageDolby; trackBy: trackByBackstageDolby; last as backstageLast"
        [lines]="backstageLast ? 'none' : 'inset'">
        <sc-avatar [photoURL]="participant.photoURL" [name]="participant.name$ | async"></sc-avatar>

        <ion-label>
          <p class="medium ion-no-padding ion-no-margin">
            {{ participant.name$ | async }}
          </p>

          <p class="micro-regular ion-no-padding ion-no-margin">
            {{ rolesService.display(participant.role) }}
          </p>
        </ion-label>

        <ion-button
          aria-label="Open Participant Menu"
          (click)="openParticipantMenu($event, participant, 'backstage')"
          class="black">
          <ion-icon src="/assets/icons/24px/more-vertical.svg" slot="icon-only"></ion-icon>
        </ion-button>
      </ion-item>
    </ion-list>

    <div
      *ngIf="
        studioSession$?.value?.confType !== 'daily' &&
        !backstageDolby.length &&
        (role$ | async) >= roleLimits.PARTICIPANT_CREATE
      "
      class="invite-prompt">
      <ion-button
        aria-label="Open Invitation Link Menu"
        (click)="openInvitationLinkMenu($event, 'Backstage')"
        class="line"
        expand="block">
        Invite Backstage
      </ion-button>

      <p class="micro-regular ion-text-center">
        Viewers can watch and listen to the session but only communicate through chat. However, managers can move
        viewers to the Main Stage at anytime to be included in the recording.
      </p>
    </div>
  </ion-list>
</ion-content>
